import { motion } from "framer-motion";
import { CLOWNFISH, CLOWNFISH_IS_SAMPLE } from "@/lib/clownfish";

export function ClownfishGallery() {
  return (
    <div data-testid="clownfish-gallery" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {CLOWNFISH.map((f, i) => (
        <motion.div
          key={f.name}
          data-testid={`clownfish-card-${i}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.5, delay: (i % 5) * 0.06 }}
          className="group relative rounded-2xl overflow-hidden border border-white/10 card-glow bg-white/[0.02]"
        >
          <div className="aspect-square overflow-hidden">
            <img
              src={f.img}
              alt={`${f.name} exotic clownfish`}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-[1.1s] group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-void via-void/10 to-transparent" />
          </div>
          <div className="absolute top-3 left-3">
            <span className="mono-label text-[0.6rem] text-cyan bg-void/60 backdrop-blur px-2.5 py-1 rounded-full border border-cyan/20">
              {f.tag}
            </span>
          </div>
          <div className="p-4">
            <h3 className="font-display text-lg leading-tight mb-1.5">{f.name}</h3>
            <p className="text-white/50 text-xs leading-relaxed">{f.desc}</p>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
